import { useDebugStore } from '@/stores/debug.store';
import { isDevelopment, isStaging } from '@/utils/environment.utils';
import type { NavigationGuard } from 'vue-router';

const resolveDebugQuery = (to: Parameters<NavigationGuard>[0]): boolean => {
  const rawQuery = to.query.inspector;
  const queryValue = Array.isArray(rawQuery) ? rawQuery[0] : rawQuery;
  const searchValue =
    typeof window !== 'undefined'
      ? new URLSearchParams(window.location.search).get('inspector')
      : undefined;

  return (queryValue ?? searchValue) === 'true';
};

export const debugMiddlewares: Record<string, NavigationGuard> = {
  syncDebugStatus: (to, _from, next) => {
    const debugStore = useDebugStore();
    const isLocalhost =
      typeof window !== 'undefined' &&
      ['localhost', '127.0.0.1'].includes(window.location.hostname);
    const alwaysOn = isDevelopment() || isStaging() || import.meta.env.DEV || isLocalhost;
    debugStore.setEnabled(alwaysOn || resolveDebugQuery(to));
    next();
  },
};
